import React, { useEffect, useState } from 'react'

import InService from '../../../../components/Project/Resources/InService/InService'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useSelectionTable from '../../../../elements/Hooks/useSelectionTable'
import useModalData from '../../../../elements/Hooks/useModalData'
import { message } from 'antd'
import { get, omit, pick } from 'lodash'
import Orders from '../../../../api/Sales/Orders'

const api = new Orders()

function InServiceCont(props) {
  const { project } = props
  const { list, fetching, fetch } = useFetchList(() => api.lines.listActive(get(project, 'project.salesContract')))
  const { tableRef, selection, selectAll, setSelection, toggleSelection, toggleAll, isSelected } = useSelectionTable()

  const {
    visible,
    modalType,
    object: booking,
    submitting,
    setSubmitting,
    formRef,
    onShow,
    onCancel,
    checkForm,
  } = useModalData(undefined, undefined, undefined, fetch)

  async function update() {
    const updatedObject = await checkForm()
    setSubmitting(true)
    try {
      await api.lines.update(
        omit({ ...updatedObject, ...pick(booking, ['_id', '_key']) }, [
          'order',
          'contract',
          'invoiced',
          'amount',
          'type',
          'delivery',
        ]),
        'in-service'
      )
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <InService
      {...{
        list,
        project,
        fetching,
        submitting,
        visible,
        fetch,
        booking,
        onShow,
        onCancel,
        checkForm,
        update,
        modalType,
        formRef,
        //selection
        selection,
        selectAll,
        setSelection,
        tableRef,
        toggleSelection,
        toggleAll,
        isSelected,
      }}
    />
  )
}

InServiceCont.propTypes = {}
InServiceCont.defaultProps = {}

export default (InServiceCont)
